import { computed, onMounted } from "vue";
import { useRoute } from "@nuxtjs/composition-api";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const route = useRoute();

const articles = computed(() => {
  let list = [];

  const actualRoute = route.value.path.substring(6, route.value.path.length);

  for (let i = 0; i < props.dataProvider.items.length; i++) {
    if (props.dataProvider.items[i].target !== actualRoute && list.length < 2) {
      list.push(props.dataProvider.items[i]);
    }
  }

  return list;
});
const { reveal } = useScrollTriggerAnimation();
const tpl_root = templateRef("tpl_root");
const tpl_title = templateRef("tpl_title");
const tpl_buttonWrapper = templateRef("tpl_buttonWrapper");
const tpl_button = templateRef("tpl_button");

onMounted(() => {
  reveal(tpl_title.value, tpl_root.value.$el, "bottom", {
    intensity: "strong",
    fade: true,
  });

  reveal(tpl_button.value.$el, tpl_buttonWrapper.value, "scale-up", {
    intensity: "normal",
    fade: true,
    duration: "normal",
  });
});

return { __sfc: true,props, route, articles, reveal, tpl_root, tpl_title, tpl_buttonWrapper, tpl_button }
}

}